import Loading from "../../Loading";

export default function SignInRedirect() {
  return <Loading fullscreen storeSpin />;
}
